import { createSlice } from '@reduxjs/toolkit'
import { type MetaData } from '../../../types/types'

interface IinitialState {
  metadata: MetaData
}
const initialState: IinitialState = {
  metadata: {
    toatlCount: 0,
    totalPage: 0,
    nextPage: 0,
    prevPage: 0
  }
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setMetaData: (state, action) => {
      state.metadata = action.payload
    }
  }
})

export const { setMetaData } = adminSlice.actions
export default adminSlice.reducer
